var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservedSlotAsset18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5643",
    "data-name": "Group 5643",
    transform: "translate(7220 2593)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21499",
    "data-name": "Ellipse 21499",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(-7219 -2592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_46",
    "data-name": "Exclusion 46",
    d: "M9,18a9,9,0,1,1,9-9A9,9,0,0,1,9,18ZM6.125,3.513A1.084,1.084,0,0,0,5.045,4.67v8.5a1.133,1.133,0,0,0,1.126,1.049A1.1,1.1,0,0,0,7.3,13.17V10.394H8.328l2.04,3.363a1.056,1.056,0,0,0,.9.463,1.119,1.119,0,0,0,.561-.154,1.157,1.157,0,0,0,.535-.732.933.933,0,0,0-.113-.734l-1.728-2.484a3.307,3.307,0,0,0,2.391-3.173,3.343,3.343,0,0,0-3.528-3.43ZM9.319,8.5H7.3V5.5H9.386A1.4,1.4,0,0,1,10.671,7,1.414,1.414,0,0,1,9.319,8.5Z",
    transform: "translate(-7220 -2593)",
    fill: "#a0a09f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservedSlotAsset18);
export default __webpack_public_path__ + "static/media/reserved_slot_asset_18.44c04f1aa6d2061ddf2fead19936db4e.svg";
export { ForwardRef as ReactComponent };